import type { AuthAdapter, AdapterResult } from "./types";

export class EmailOtpAdapter implements AuthAdapter {
  readonly provider = "email" as const;

  async authenticate(params: {
    email: string;
    code: string;
  }): Promise<AdapterResult> {
    return {
      authHeaders: {
        "OS-Email": params.email,
        "OS-Code": params.code,
      },
    };
  }
}
